import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { AlertTriangle } from 'lucide-react';

const titles = {
  category: 'Delete category?',
  sub: 'Delete subcategory?',
  child: 'Delete detail?',
};

const descriptions = {
  category: 'This will remove the entire category and all its subcategories. Transactions already assigned will keep their labels.',
  sub: 'This removes the subcategory and its details. Transactions already tagged keep their labels.',
  child: 'Removes this detail. Transactions tagged with it keep the label.',
};

export function DeleteConfirmDialog({ deleteConfirm, onCancel, onConfirm }) {
  if (!deleteConfirm) return (
    <Dialog open={false}><DialogContent className="max-w-sm"><DialogHeader><DialogTitle /></DialogHeader></DialogContent></Dialog>
  );

  const { type, cat, subIdx, child } = deleteConfirm;
  const renderPath = () => {
    if (type === 'category') return <span className="font-semibold">{cat.name}</span>;
    if (type === 'sub') return <span>{cat.name} › <span className="font-semibold">{cat.subcategories[subIdx].name}</span></span>;
    return <span>{cat.name} › {cat.subcategories[subIdx].name} › <span className="font-semibold">{child}</span></span>;
  };

  return (
    <Dialog open onOpenChange={v => { if (!v) onCancel(); }}>
      <DialogContent className="max-w-sm" data-testid="delete-cat-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4 text-red-500" />
            {titles[type]}
          </DialogTitle>
          <DialogDescription>{descriptions[type]}</DialogDescription>
        </DialogHeader>
        <div className="rounded-lg border border-border/60 bg-[#faf8f4] p-3 text-xs">{renderPath()}</div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>Cancel</Button>
          <Button variant="destructive" onClick={onConfirm} data-testid="confirm-delete-cat-btn">Delete</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
